// Shared public-page chrome (sticky topbar + footer) for the landing page
// and the three value-proposition detail pages.
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/AuthContext";
import { BgPhotos } from "../../components/BgPhotos";
import { LangThemeControls } from "../../components/LangThemeControls";

export function LandingShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <div className="min-h-full">
      <BgPhotos />
      <header className="border-b border-border bg-panel/80 backdrop-blur sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-color.png" alt="" className="h-7 w-auto" />
            <span className="font-semibold">{t("common.appName")}</span>
          </Link>
          <nav className="flex items-center gap-3">
            <Link to="/#pricing" className="nav-item hidden sm:flex">{t("nav.pricing")}</Link>
            <LangThemeControls />
            {user ? (
              <Link to="/app" className="btn-primary">{t("nav.openApp")}</Link>
            ) : (
              <Link to="/login" className="btn-primary">{t("nav.signIn")}</Link>
            )}
          </nav>
        </div>
      </header>
      {children}
      <footer className="border-t border-border mt-8">
        <div className="max-w-6xl mx-auto px-4 py-6 flex items-center justify-between text-xs text-muted">
          <span>© {new Date().getFullYear()} Complete Inverter</span>
          <span>v{__APP_VERSION__}</span>
        </div>
      </footer>
    </div>
  );
}
